import React from "react";
import { Navigate } from "react-router-dom";

function ProtectedRoute({ children }) {
  const token = localStorage.getItem("adminToken");

  // اگر توکن وجود نداشت، به صفحه لاگین برو
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // اگر توکن وجود داشت، محتوای محافظت‌شده را نمایش بده
  return children;
}

export default ProtectedRoute;